module.exports = new __parcel__URL__("sand.c4c51c1c.jpg").toString();